// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/schenkelfeder-in-der-beleuchtungstechnik/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSchenkelfederInDerBeleuchtungstechnikDE: PageEntry = {
  id: "example.produkte-schenkelfeder-in-der-beleuchtungstechnik",
  locale: "de",
  slug: "produkte/schenkelfeder-in-der-beleuchtungstechnik",
  seo: {
    title: "Schenkelfeder in der Beleuchtungstechnik | Dietz GmbH",
    description: "Schenkelfeder mit nach innen gebogenem Federende für die Befestigung von Leuchten in Hohlraumdecken. Automatisierung des in den Federkörper gebogenen Feder-Endes.",
  },
  type: "post",
  h1: "Schenkelfeder in der Beleuchtungstechnik",
  intro: "Schenkelfeder mit nach innen gebogenem Federende für die Befestigung von Leuchten in Hohlraumdecken. Automatisierung des in den Federkörper gebogenen Feder-Endes.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ-schenkelfederLeuchten.jpg", alt: "Schenkelfeder Leuchten", width: 1400, height: 1120 }
  ],
};
